import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { MultipleUserAvatar } from "../MultipleUserAvatar";
import { UserDisplayName } from "../UserDisplayName";
import { DatesDisplay } from "./DatesDisplay";

type AuthorsMetadataProps = {
  users: {
    name: string | null;
    email?: string | null;
    photo_url?: string | null;
  }[];
  dateCreated: string;
  dateUpdated: string;
};

export const AuthorsMetadata = ({
  users,
  dateCreated,
  dateUpdated,
}: AuthorsMetadataProps) => {
  return (
    <div className="flex items-center gap-4">
      <DatesDisplay
        dateCreated={dateCreated}
        dateUpdated={dateUpdated}
        className="text-foreground-5 text-xs"
      />

      <Tooltip>
        <TooltipTrigger asChild>
          <MultipleUserAvatar users={users} />
        </TooltipTrigger>
        <TooltipContent className="flex flex-col gap-2">
          {users.map((user) => (
            <UserDisplayName key={user.name + (user.email ?? "")} user={user} />
          ))}
        </TooltipContent>
      </Tooltip>
    </div>
  );
};
